import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const WesternUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Western University"
      universityShortName="Western"
      slug="western-university"
      seoTitle="Western University Study Rooms | London Campus Study Guide"
      seoDescription="Complete guide to study rooms at Western University. Find D.B. Weldon Library floors and zones. Plus free 24/7 online alternative."
      seoKeywords="western university study rooms, western library, weldon library, london ontario university, uwo study spaces"
      canonicalUrl="/study-room/western-university/"
      heroDescription="A comprehensive guide to study rooms at Western, including the D.B. Weldon Library's various zones and floors."
      libraryWebsiteUrl="https://www.lib.uwo.ca/"
      libraryWebsiteName="Western Libraries"
      studySpaces={[
        {
          name: "D.B. Weldon Library - Group Study Rooms",
          features: "Bookable rooms with media equipment on ground, mezzanine, and second floors.",
          feedback: "Can be hard to obtain; book early for best availability."
        },
        {
          name: "Conversation-Friendly Zones",
          features: "Lounge seating and tables on ground, mezzanine, main, and second floors.",
          feedback: "Good for casual group work and socializing."
        },
        {
          name: "Quiet Study Zone (Third Floor)",
          features: "300 seats for quiet individual study.",
          feedback: "Good atmosphere for focused work; can fill during exams."
        },
        {
          name: "Silent Zone (Fourth Floor)",
          features: "More than 450 seats for complete silence.",
          feedback: "Fills quickly during exam periods; highly valued by students."
        },
        {
          name: "Graduate Study Rooms",
          features: "Dedicated rooms for graduate students, accessible via ONECard.",
          feedback: "Exclusive to grad students; appreciated for privacy."
        },
        {
          name: "Family Room (Mezzanine)",
          features: "Special room for students with children.",
          feedback: "Praised for supporting student parents; rare resource."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            For group projects, book one of the <strong>media-equipped rooms</strong> early. If you crave silence, stake out a spot on the <strong>fourth floor</strong>.
          </p>
          <p className="mb-4">
            Students love the abundance of seats but warn that the <strong>silent fourth floor fills quickly</strong> during exam periods.
          </p>
          <p>
            Families should use the <strong>mezzanine family room</strong>—it's a rare resource for student parents.
          </p>
        </>
      }
      summaryTips={[
        "Book media-equipped rooms early: Popular for group presentations and projects.",
        "Head to the fourth floor for silence: Over 450 seats but fills fast during exams.",
        "Use the third floor for quiet study: 300 seats with a quieter atmosphere.",
        "Family room available: Mezzanine offers space for students with children.",
        "Use CSW when campus is full: Virtual study rooms offer guaranteed availability."
      ]}
    />
  );
};

export default WesternUniversity;
